// Importing React and related hooks
import React, { useState, useEffect } from "react";

// Importing custom GroupSelector styles
import "../../styles/practicePage/GrouperSelector.css";

const GroupSelector = ({ onGroupChange, reset }) => {
  // State hook to manage the number of groups
  const [groups, setGroups] = useState(1);

  // Function to handle input value change for group count
  const handleChange = (event) => {
    let value = parseInt(event.target.value, 10); // Convert input value to integer

    // Ensure the value stays within the allowed range (1 to 100)
    if (value > 100) {
      value = 100;
    } else if (value < 1) {
      value = 1;
    }

    setGroups(value); // Update the local state for groups
    onGroupChange(value); // Pass updated group count to parent component
  };

  // Effect hook to reset the group count when the reset prop changes
  useEffect(() => {
    if (reset) {
      setGroups(1); // Reset group count to 1
      onGroupChange(1); // Reset parent value to 1
    }
  }, [reset, onGroupChange]); // Re-run effect when reset or onGroupChange changes

  return (
    <div className="groupSelector mt-3">
      {/* Label for the group count input */}
      <label htmlFor="group-count" className="groupLabel">
        Groupers of 5:{" "}
      </label>

      {/* Input field for entering the number of groups */}
      <input
        id="group-count"
        className="groupInput mt-2"
        type="number" // Numeric input for group count
        min="1" // Minimum value of 1
        max="100" // Maximum value of 100
        value={groups} // Set current value to local state
        onChange={handleChange} // Trigger onChange when input value is modified
        placeholder="Enter number"
        onInvalid={(e) =>
          e.target.setCustomValidity("Please enter a number between 1 and 100")
        }
        onInput={(e) => e.target.setCustomValidity("")} // Clears error when corrected
      />
    </div>
  );
};

export default GroupSelector;
